const MuiSelect = {
    defaultProps: {
        variant: 'outlined',
        size: 'medium'
    }
};
export { MuiSelect };

//# sourceMappingURL=simpleselect-overrides.js.map